
// 员工档案 接口相关
import request from "../../untils/request.js"

/**
 * 
 *  post
 *  
 */

//新增科室档案
export const addDept = (data) => {
    return request.post("/outpatient/addDept", data )
}

//修改科室档案
export const updateDept = (data) => {
    return request.post("/outpatient/updateDept", data )
}

// 图片处理
export const builderImage = (data) => {
    return request.post("/outpatient/upload/image", data )
}

/**
 * 
 *  get
 *  
 */
//更新员工状态
export const updateStatus = (params) => {
  return request.get("/outpatient/updateStatus", { params } )
}
// 查询员工列表
export const selectDeptStaff = (params) => {
    return request.get("/outpatient/selectDeptStaff", { params } )
}

// 查询员工列表 DUI √
export const yglist = (params) => {
    return request.get("/outpatient/list", { params } )
}

// 查询所有用户
export const selectList = (params) => {
    return request.get("/outpatient/selectList", { params } )
}
// 获取字典数据
export const dict = (params) => {
    return request.get("/outpatient/index/dict", { params } )
}
/**
 * 
 * DELETE 
 *  
 */   


// 暴露
export default{
	selectList,dict,builderImage,yglist,updateStatus,selectDeptStaff
}